<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ApolloQuery
        :query="configsQuery"
        :variables="{
          pageSize: $options.pageSize,
          cursor: null,
          orderBy: $options.orderBy
        }"
        :notifyOnNetworkStatusChange="false"
      >
        <template v-slot="{ result: { error, data }, query }">
          <div v-if="error" class="error apollo">
            An error occurred while retrieving config history
          </div>
          <div v-else-if="data && data.configs.edges && data.configs.edges.length">
            <div v-for="(edge, index) in data.configs.edges" :key="edge.node.edition">
              <div v-if="index === 0">
                <router-link :to="{ path: '/config' }">
                  <config-card :config="edge.node" :readonly="true" style="border: 2px solid">
                    <template v-slot:icon>
                      <div />
                    </template>
                    <template v-slot:title>
                      <div style="font-weight: 400; padding-top: 1em">
                        <span>
                          {{ edge.node.createdAt | moment }}
                        </span>
                        <span v-if="index === 0" style="color: green; padding-left: 1em">
                          <em>Current</em>
                        </span>
                      </div>
                    </template>
                  </config-card>
                </router-link>
              </div>
              <div v-else>
                <config-card :config="edge.node" :readonly="true">
                  <template v-slot:icon>
                    <div />
                  </template>
                  <template v-slot:title>
                    <div style="font-weight: 400; padding-top: 1em">
                      <span>
                        {{ edge.node.createdAt | moment }}
                      </span>
                      <span v-if="index === 0" style="color: green; padding-left: 1em">
                        <em>Current</em>
                      </span>
                    </div>
                  </template>
                </config-card>
              </div>
            </div>
            <md-button
              class="md-info"
              v-if="data.configs.pageInfo.hasNextPage"
              :disabled="isLoadingMore"
              @click="loadMore(query, data.configs.pageInfo.endCursor)"
            >
              Load more
            </md-button>
          </div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ConfigCard from "@/components/Cards/Config/ConfigCard";
import { ConfigsQuery } from "@/graphql.js";

export default {
  name: "ConfigHistory",
  components: {
    ConfigCard,
  },
  pageSize: 25,
  orderBy: { edition: 'desc' },
  data() {
    return {
      isLoadingMore: false,
    }
  },
  methods: {
    configsQuery() {
      return ConfigsQuery;
    },
    async loadMore(query, endCursor) {
      this.isLoadingMore = true;
      try {
        await query.fetchMore({
          variables: { cursor: endCursor },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const newEdges = fetchMoreResult.configs.edges;
            const pageInfo = fetchMoreResult.configs.pageInfo;

            return newEdges.length ? {
              ...previousResult,
              configs: {
                ...previousResult.configs,
                edges: [...previousResult.configs.edges, ...newEdges],
                pageInfo,
              }
            } : previousResult
          },
        })
      } finally {
        this.isLoadingMore = false;
      }
    },
  },
  filters: {
    moment(datetime) {
      return moment(datetime).utc().format('YYYY-MM-DD hh:mm A UTC');
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
